var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:[ 'content-section', _vm.section.classes ],attrs:{"data-section-index":_vm.idx}},[_c('div',{class:[ 'content', { 'fade-in': _vm.showContent } ]},_vm._l((_vm.section.items),function(item,index){return _c(item.type,{key:index,tag:"component",attrs:{"item":item},on:{"action":_vm.onAction}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }